export default "__VITE_ASSET__D3HrnYaS__"